export const HOME = {
  heroStartAssessment: 'home-hero-start-assessment',
  heroBookConsultation: 'home-hero-book-consultation',
  finalCtaBook: 'home-final-cta-book',
  emergentLink: 'emergent-link',
};

export const NAV = {
  logo: 'nav-logo',
  linkAssessment: 'nav-link-assessment',
  linkConsultation: 'nav-link-consultation',
  linkProducts: 'nav-link-products',
  linkLearn: 'nav-link-learn',
  linkAbout: 'nav-link-about',
  linkLogin: 'nav-link-login',
  linkDashboard: 'nav-link-dashboard',
  linkAdmin: 'nav-link-admin',
  linkDoctor: 'nav-link-doctor',
  btnLogout: 'nav-btn-logout',
  btnCart: 'nav-btn-cart',
  mobileMenuToggle: 'nav-mobile-menu-toggle',
};

export const AUTH = {
  emailInput: 'auth-email-input',
  passwordInput: 'auth-password-input',
  nameInput: 'auth-name-input',
  submitBtn: 'auth-submit-btn',
  googleBtn: 'auth-google-btn',
  toggleLink: 'auth-toggle-link',
};

export const ASSESSMENT = {
  startBtn: 'assessment-start-btn',
  optionBtn: (id) => `assessment-option-${id}`,
  progress: 'assessment-progress',
  backBtn: 'assessment-back-btn',
  resultPrimary: 'assessment-result-primary',
  resultSecondary: 'assessment-result-secondary',
  resultBookConsultation: 'assessment-result-book-consultation',
};

export const CONSULT = {
  dayTab: (date) => `consult-day-${date}`,
  slotBtn: (dt) => `consult-slot-${dt}`,
  confirmBtn: 'consult-confirm-btn',
  payBtn: 'consult-pay-btn',
  reasonInput: 'consult-reason-input',
};

export const SHOP = {
  productCard: (id) => `product-card-${id}`,
  addToCartBtn: 'product-add-to-cart',
  cartItemQty: (id) => `cart-item-qty-${id}`,
  cartRemove: (id) => `cart-remove-${id}`,
  checkoutBtn: 'cart-checkout-btn',
  placeOrderBtn: 'checkout-place-order',
};

export const LEARN = {
  articleCard: (slug) => `article-card-${slug}`,
};

export const ADMIN = {
  navHome: 'admin-nav-home',
  navProducts: 'admin-nav-products',
  navOrders: 'admin-nav-orders',
  navAppointments: 'admin-nav-appointments',
  navUsers: 'admin-nav-users',
  navDoctors: 'admin-nav-doctors',
  navArticles: 'admin-nav-articles',
  navTestimonials: 'admin-nav-testimonials',
  navFaqs: 'admin-nav-faqs',
  navConcerns: 'admin-nav-concerns',
  navEvidence: 'admin-nav-evidence',
  navCoupons: 'admin-nav-coupons',
  navSettings: 'admin-nav-settings',
  newBtn: 'admin-new-btn',
  saveBtn: 'admin-save-btn',
  deleteBtn: (id) => `admin-delete-${id}`,
  editBtn: (id) => `admin-edit-${id}`,
};

export const DOCTOR = {
  navHome: 'doctor-nav-home',
  apptCard: (id) => `doctor-appt-${id}`,
  savePrescriptionBtn: 'doctor-save-prescription',
  addRxItemBtn: 'doctor-add-rx-item',
  downloadPdfBtn: 'doctor-download-pdf',
};
